import CreateUpdateDocumentationApprovalFlowApp from '../Functionality/CreateUpdateDocumentationApprovalFlowApp';
import HeadTittle from '../../../components/HeadTittle';
import ButtonIcon from '../../../components/buttons/ButtonIcon';
import { AddIcon, CleanIcon, DeleteIconsOptions, EditIcon, IconClip } from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../components/DivContainerBody';
import DividerWithText from '../../../components/DividerWithText';
import { CustomSelectAndChildren } from '../../../components/CustomSelectAndChildren';
import { Box, MenuItem } from '@mui/material';
import { CustomTextField } from '../../../components/CustomTextField';
import CustomPhotoPicker from '../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../Helpers/fileType';
import CustomSortableList from '../../../components/CustomSortableList';
import DraggableCard from '../../Dashboard/Traffic/Manage/SubComponents/DraggableCard';
import { FIELD_TYPES_MODEL } from '../../Dashboard/Visitor/Type/Model/Model';
import CustomChip from '../../../components/CustomChip';
import { colors } from '../../../enums/colors';
import CustomTooltip from '../../../components/CustomTooltip';
import ButtonSubAction from '../../../components/buttons/ButtonSubAction';
import NotInformation from '../../../components/NotInformation';
import DeleteModal from '../../Modals/DeleteModal';
import {profileOptions} from "../Model/Model";
import {
    downloadActionFile,
    downloadLocalFile,
    EMPTY_VALUES,
    sanitizeFileName
} from "../../../Apis/functions";
import React from "react";
import CustomCard from "../../../components/CustomCard";
import { URL } from '../../../Apis/Constants';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: full stack
 */
const CreateUpdateDocumentationApprovalFlow = ({userTypeId}) => {
    const {
        t,
        id,
        emptyFields,
        approvalFlow,
        setApprovalFlow,
        tempLevel,
        handleChangeTemp,
        handleChangeFlow,
        photoPicker,
        setPhotoPicker,
        getAllDepartments,
        showDeleteModal,
        setShowDeleteModal,
        selectedLevelId,
        setSelectedLevelId,
        allServiceType,
        fieldTypes,
        tempLevelIsValid,
        handleAddDocumentationLevel,
        handleDeleteLevel,
        resetForm,
        handleOnBack,
        handleAction
    } = CreateUpdateDocumentationApprovalFlowApp({userTypeId});


    return (
        <>
            <HeadTittle
                name={id ? 'update' : 'create'}
                onBack={handleOnBack}
                divStack={
                    !id &&
                    <div>
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cudaf_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                resetForm();
                            }}
                        />
                    </div>
                }
            >
                <ButtonAction
                    id='btn_cudaf_update'
                    name={id ? 'update' : 'create'}
                    className={id ? 'btn-icon-edit' : 'btn-icon-add'}
                    Icon={id ? EditIcon : AddIcon}
                    onClick={() => {
                        handleAction();
                    }}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={'col-12'}>
                    <DividerWithText title={t('data')} />
                </div>

                <div className={'row mt-3'}>
                    <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSelectAndChildren
                            id='slt_cudaf_service_type'
                            name='serviceType'
                            trans='service_type'
                            label='lbl_cudaf_service_type'
                            showNoSelectionOption={false}
                            required={true}
                            value={approvalFlow.serviceType?.id || approvalFlow.serviceType || ''}
                            onChange={(e) => {
                                const id = e.target.value;
                                const match = Array.isArray(allServiceType) ? allServiceType.find(s => s.id === id) : null;
                                setApprovalFlow(prev => ({ ...prev, serviceType: match ?? id }));
                            }}
                            emptyFields={emptyFields}
                        >
                            {Array.isArray(allServiceType) &&
                                allServiceType.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {t(item.name)}
                                    </MenuItem>
                                ))}
                        </CustomSelectAndChildren>
                    </Box>
                    <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSelectAndChildren
                            id='slt_cudaf_profile'
                            name='profile'
                            trans='profile'
                            label='lbl_cudaf_profile'
                            showNoSelectionOption={false}
                            required={true}
                            value={approvalFlow?.profile}
                            onChange={handleChangeFlow}
                            emptyFields={emptyFields}
                        >
                            {profileOptions.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </Box>
                    <div className={'col-12'}>
                        <DividerWithText title={t('documentation')} spacing={'mb-4'} />
                    </div>
                    <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomTextField
                            required={true}
                            id={'slt_cudaf_name'}
                            name={'name'}
                            trans={'name'}
                            length={128}
                            value={tempLevel?.name}
                            onChange={handleChangeTemp}
                            emptyFields={emptyFields}
                        />
                    </Box>
                    <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSelectAndChildren
                            id='slt_cudaf_validation_department'
                            name='department'
                            trans='validation_department'
                            label='lbl_cudaf_validation_department'
                            showNoSelectionOption={false}
                            required={true}
                            value={tempLevel?.department}
                            onChange={handleChangeTemp}
                            emptyFields={emptyFields}
                        >
                            {getAllDepartments.map((item) => (
                                <MenuItem key={item.id} value={item}>
                                    {t(item.name)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </Box>
                    <Box className='col-12'>
                        <CustomSelectAndChildren
                            id='slt_cudaf_type'
                            name='type'
                            trans='type'
                            label='lbl_cudaf_type'
                            showNoSelectionOption={false}
                            required={true}
                            value={tempLevel?.type}
                            onChange={handleChangeTemp}
                            emptyFields={emptyFields}
                        >
                            {fieldTypes.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </Box>
                    <Box className='col-sm-12 col-md-12 col-xxl-12 col-lg-12'>
                        <CustomTextField
                            id={'slt_cudaf_description'}
                            name={'description'}
                            trans={'description'}
                            value={tempLevel?.description}
                            onChange={handleChangeTemp}
                            length={512}
                            multiline
                            rows={4}
                        />
                    </Box>
                    <p className="font-color-shades-950 fs-14px ibl-font-w-600 pb-2">{t("documentation_reference")}</p>
                    <Box className={'col-12'}>
                        <CustomPhotoPicker
                            id='fu_cudaf_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FILES }}
                            classWith={'w-100'}
                            showPreview={false}
                        />
                    </Box>
                    <div className='col-12 mb-4 mt-4 d-flex justify-content-end'>
                        <ButtonAction
                            id='btn_cudaf_add_new_documentation'
                            name='add_new_documentation'
                            Icon={AddIcon}
                            splitName={false}
                            className='btn-secondary-600'
                            disabled={!tempLevelIsValid}
                            onClick={() => {
                                handleAddDocumentationLevel();
                            }}
                        />
                    </div>
                </div>
                   <CustomCard classCard={"border-0 mb-70px p-16px"} classContent={"border-full-shades-300 border-radius-8px p-16px"}>
                       {approvalFlow?.levels && approvalFlow?.levels?.length > 0 ? (
                           <CustomSortableList
                               keyId="id"
                               sortKey="levelNumber"
                               items={approvalFlow.levels}
                               dynamicHeight={false}
                               setItems={(newLevels) =>
                                   setApprovalFlow(prev => ({
                                       ...prev,
                                       levels: newLevels.map((l, i) => ({
                                           ...l,
                                           levelNumber: i + 1
                                       }))
                                   }))
                               }
                               renderItem={(item, index, isDragging) => {
                                   const fieldType = FIELD_TYPES_MODEL().find((f) => f.id === item.type);
                                   return (
                                       <DraggableCard
                                           item={item.levelNumber}
                                           backgroundColor={isDragging ? 'card-accent-50' : 'background-shades-50'}
                                           className={`maxh-50px ${approvalFlow.levels.length <= 1  ? "mb-0" : "mb-2"}`}
                                           classNameIconContainer={"maxh-50px"}
                                           body={() => (
                                               <div className='row w-100 px-3 py-2 align-items-center gx-2'>
                                                   <div className='col-3 col-md-3 mb-2 mb-md-0 p-0 d-flex justify-content-center align-items-center'>
                                                       <CustomTooltip
                                                           tooltipClasses={"d-flex"}
                                                           text={item.name}
                                                           classes={"text-ellipsis ibl-font-w-400 fs-14px"}
                                                           showIfTruncated={true}
                                                       />
                                                   </div>
                                                   <div className='col-3 col-md-2 mb-2 mb-md-0 d-flex justify-content-center p-0 '>
                                                       <CustomChip
                                                           background={colors.secondary100}
                                                           fontColor={colors.secondary700}
                                                           borderColor={colors.secondary150}
                                                           legend={fieldType?.name || item.type}
                                                           icon={fieldType?.icon}
                                                           className={'icon-color-secondary-700'}
                                                       />
                                                   </div>
                                                   <div className='col-3 col-md-2 mb-2 mb-md-0 d-flex justify-content-center p-0 '>
                                                       <CustomChip
                                                           background={colors.secondary100}
                                                           fontColor={colors.secondary700}
                                                           borderColor={colors.secondary150}
                                                           legend={item.department.name || EMPTY_VALUES.DEFAULT}
                                                       />
                                                   </div>
                                                   <div className='col-2 col-md-2 mb-2 mb-md-0 d-flex justify-content-center p-0'>
                                                       <CustomTooltip
                                                           tooltipClasses={"d-flex"}
                                                           text={item.description || EMPTY_VALUES.DEFAULT}
                                                           classes={'text-ellipsis ibl-font-w-400 fs-14px'}
                                                           showIfTruncated={true}
                                                           placement={'top'}
                                                       />
                                                   </div>
                                                   <div className='col-1 col-md-3 d-flex align-items-center gap-4 justify-content-md-end p-0'>
                                                    <div>
                                                      {!item?.fileUploadDto?.id && !item?.file ? (
                                                          EMPTY_VALUES.DEFAULT
                                                      ) : (
                                                          <ButtonSubAction
                                                              name={sanitizeFileName(item?.file?.name || item?.fileUploadDto?.userFileNames?.[0])}
                                                              Icon={IconClip}
                                                              iconProps="icon-color-secondary-700"
                                                              className="font-color-secondary-700 m-0 p-0 d-flex"
                                                              nameClass="fs-12px text-ellipsis m-0 p-0"
                                                              onClick={() => {
                                                                  if (id) {
                                                                      downloadActionFile(URL + item?.fileUploadDto?.filePath);
                                                                  } else {
                                                                      downloadLocalFile(item?.file);
                                                                  }
                                                              }}
                                                          />
                                                      )}
                                                    </div>
                                                    <div>
                                                       <DeleteIconsOptions
                                                           className='icon-color-shades-400 ms-2 w-h-16px'
                                                           onClick={(e) => {
                                                               e.stopPropagation();
                                                               setSelectedLevelId(item.id);
                                                               setShowDeleteModal(true);
                                                           }}
                                                       />
                                                    </div>
                                                   </div>
                                               </div>
                                           )}
                                       />
                                   );
                               }}
                           />
                       ) : (
                           <NotInformation text={t('you_havent_created_any_documentation_yet')} card={true} />
                       )}
                   </CustomCard>
            </DivContainerBody>

            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                data={[selectedLevelId]}
                onClickFn={() => {
                    if (selectedLevelId !== null) {
                        handleDeleteLevel(selectedLevelId);
                    }
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                title_modal={t('delete_level')}
                element_modal={t('level')}
            />
        </>
    );
};

export default CreateUpdateDocumentationApprovalFlow;
